import React from "react";
import { Megaphone, Mail, Target, Share2, Lock } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const CHANNELS = [
  { icon: Target, name: "Google Ads", desc: "Campaign spend, impressions, clicks, and cost per acquisition." },
  { icon: Mail, name: "Email Marketing", desc: "Campaign sends, open rates, click rates, and list growth." },
  { icon: Share2, name: "Social & Paid Social", desc: "Reach, engagement, and ad performance across platforms." },
];

export default function Marketing() {
  return (
    <div className="space-y-6">
      <PageHeader title="Marketing" subtitle="Advertising and campaign performance across the group." />

      <Card className="overflow-hidden rounded-[14px] border-[var(--pb-border)] bg-white shadow-[var(--pb-shadow-sm)]">
        <div className="relative">
          <div className="pb-grad-orbs pointer-events-none absolute inset-0" />
          <CardContent className="relative flex flex-col items-start gap-3 p-8">
            <span className="flex h-11 w-11 items-center justify-center rounded-[12px] bg-[rgba(24,52,74,0.08)] text-[#18344A]"><Megaphone className="h-5 w-5" /></span>
            <h2 className="font-display text-xl font-semibold text-[#18344A]">Marketing analytics are on the roadmap</h2>
            <p className="max-w-xl text-sm text-[rgba(48,56,60,0.7)]">
              Connect Google Ads and your email platform to track spend, ROI, and campaign performance for every venue — all in one place.
            </p>
            <Button data-testid="connect-marketing-button" disabled className="mt-2 gap-2 rounded-full bg-[#18344A] text-white opacity-70">
              <Lock className="h-4 w-4" /> Connect channels (coming soon)
            </Button>
          </CardContent>
        </div>
      </Card>

      <div className="grid gap-6 md:grid-cols-3">
        {CHANNELS.map((c) => (
          <Card key={c.name} className="rounded-[14px] border-[var(--pb-border)] bg-white shadow-[var(--pb-shadow-sm)]">
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-[rgba(82,110,126,0.12)] text-[#526E7E]"><c.icon className="h-4 w-4" /></span>
                <Badge variant="outline" className="rounded-full border-[rgba(183,165,142,0.5)] bg-[rgba(183,165,142,0.18)] text-[11px] text-[#7a6a4f]">Coming soon</Badge>
              </div>
              <CardTitle className="pt-2 font-display text-base font-semibold text-[#18344A]">{c.name}</CardTitle>
            </CardHeader>
            <CardContent><p className="text-sm text-[rgba(48,56,60,0.65)]">{c.desc}</p></CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
